// extracted by mini-css-extract-plugin
export default {"avatar":"b1kQlZ","brandedAvatar":"c1kQlZ","image":"d1kQlZ","icon":"e1kQlZ","brandedIcon":"f1kQlZ"};